<template>
  <div>
    <div v-if="!isPrint">
      <el-button type="primary" style="margin-bottom:5px" @click="printPage">打印</el-button>
    </div>
    <div id="printContent">
      <table class="table">
        <tr>
          <td>名称</td>
          <td>一体机</td>
          <td style="width:150px">凯斯博订单号</td>
          <td>(KSP00091963)</td>
        </tr>
        <tr>
          <td>规格</td>
          <td>15KW</td>
          <td style="width:150px">数量</td>
          <td>1</td>
        </tr>
        <tr>
          <td>项目名称</td>
          <td colspan="3">佛山市妇女儿童医院2批</td>
        </tr>
        <tr>
          <td rowspan="3" style="border-right:none;width: 120px;">
            <img src="../../../public/img/ksbIcon.png">
          </td>
          <td colspan="3" style="border-bottom:none;border-top:none;border-left:none">凯斯博电梯有限公司</td>
        </tr>
        <tr>
          <td colspan="3" style="border-bottom:none;border-top:none;border-left:none">KSP-Kasper Elevator Co.,Ltd.</td>
        </tr>
        <tr>
          <td colspan="3" style="border-top:none;border-left:none">江苏省盐城市亭湖区太湖路13号  0515-86028051</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isPrint:false,
      };
    },
    methods:{
      printPage() {
        this.isPrint = true;
        this.$nextTick(()=>{
          document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
          window.print();
          window.location.reload();
          this.isPrint = false;
          return false;
        });
       
      },
    },
  };
</script>

<style lang="scss" scoped>
.table{
  margin: 0;
  width: 700px;
  border-collapse: collapse;
}
.table td{
  border: 1px solid #333;
  margin: 0;
  padding: 10px;
}
</style>
